"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningPlacesEnd = void 0;
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var WarningPlacesEnd = exports.WarningPlacesEnd = function WarningPlacesEnd(_ref) {
  var flight = _ref.flight,
    hotel = _ref.hotel,
    className = _ref.className,
    isHotelOnly = _ref.isHotelOnly;
  if (!(flight === 'few') && !(hotel === 'few')) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, !isHotelOnly ? /*#__PURE__*/_react["default"].createElement("p", null, _localization.i18n.t('hotelcard.card.fewFlight')) : /*#__PURE__*/_react["default"].createElement("p", null, _localization.i18n.t('hotelcard.card.fewHotel')));
};